import React from 'react'
import { OfferProvider } from './hooks/offer'
import Layout from './layouts/Default'
import Page from './pages/Parcerias'
import 'veloe-ds/lib/main.css'
import { QueryClient, QueryClientProvider } from 'react-query'

const client = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			cacheTime: 1000 * 60 * 30, // 30 minutes
			staleTime: Infinity
		}
	}
})

function App() {
	return (
		<QueryClientProvider client={client}>
			<OfferProvider>
				<Layout>
					<Page />
				</Layout>
			</OfferProvider>
		</QueryClientProvider>
	)
}

export default App
